module.exports = __webpack_public_path__ + "img/vertical_7_7_8017.a84706fb.png";